// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"ContactPersonsTab_tabContainer__1B5NT","button":"ContactPersonsTab_button__3Oo1g"};